// #region import
import Vue from 'vue'
import VueRouter from 'vue-router'
// #endregion

// #region init
Vue.use(VueRouter)
// #endregion

// #region routes
const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      next('/admin')
    },
  },
  {
    path: '/admin',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Home.vue'),
    meta: { currentUser: true },
  },
  {
    path: '/usermanagement',
    name: 'User Management',
    component: () => import(/* webpackChunkName: "User Management" */ '@/views/vUserManagement.vue'),
  },
  {
    path: '/development',
    name: 'Development',
    component: () => import(/* webpackChunkName: "Development" */ '@/views/Development.vue'),
    // meta: { currentUser: true },
  },
  {
    path: '*',
    name: 'Not Found',
    component: () => import(/* webpackChunkName: "Not Found" */ '@/views/vNotFound.vue'),
  },
]
// #endregion

// #region ctor
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
// #endregion

// #region guards
router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.currentUser)) {
    if (!router.app.$store) {
      // TODO this is a very bad temporarily fix
      setTimeout(() => {
        if (!router.app.$store?.state.authentication.currentUser) {
          next('/usermanagement?mode=signIn')
        } else {
          next()
        }
      }, 1000)
    } else {
      if (!router.app.$store?.state.authentication.currentUser) {
        next('/usermanagement?mode=signIn')
      } else {
        next()
      }
    }
  } else {
    next()
  }
})
// #endregion

export default router
